import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Country } from '../../business/models/country.model';
import { State } from '../../business/models/state.model';

@Injectable()
export class CountriesService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) {}

  /**
   * returns Array List of Countries
   * @return {Promise<Country[]>}
   */
  async getCountries(): Promise<Country[]> {
    const URL = `${environment.airportsApiUrl}/countries`;
    try {
      const RESPONSE: any = await this._http.get(URL).toPromise();

      if (!RESPONSE) {
        this._errorHandler.handleError(new Error('API did not return valid countries Obj'));
      } else {
        return (RESPONSE || []).map(d => Country.parse(d));
      }
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  async getStates(countryCode: string): Promise<State []> {
    const URL = `${environment.airportsApiUrl}/states/${countryCode}`;
    try {
      const RESPONSE: any = await this._http.get(URL).toPromise();

      if (!RESPONSE) {
        this._errorHandler.handleError(new Error('API did not return valid states Obj'));
      } else {
        return (RESPONSE || []).map(d => State.parse(d));
      }
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }
}
